import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';

const theme = responsiveFontSizes(createMuiTheme({
  typography: {
    fontFamily: ['Fira Sans', 'sans-serif'].join(','),
    fontSize: 14,
    lineHeight: 28,
    h1: {
      fontFamily: 'Playfair Display,sans-serif',
      fontSize: 80,
      color: '#404040',
    },
    h2: {
      fontFamily: 'Playfair Display,sans-serif',
      fontSize: 44,
    },
    h3: {
      fontFamily: ['Fira Sans', 'sans-serif'].join(','),
      fontSize: 28,
    },
    body1: {
      fontSize: 14,
      fontWeight: 300,
    },
  },
  palette: {
    primary: {
      main: '#404040',
    },
    secondary: {
      main: '#F6F9E6',
    },
    success: {
      main: '#298936',
    },
    textcolor: {
      main: '#707070',
    },
    graycolor: {
      light: '#f7f7f7',
      main: '#ebebeb',
    },
    yellow: {
      main: '#E7C31B',
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          background: '#FFFDED 0% 0% no-repeat padding-box !important',
          paddingTop: 15,
        },
        '.MuiCheckbox-colorSecondary.Mui-checked': {
          color: '#404040',
        },
      },
    },
  },
}));

export default theme;
